/** Cart lines with no known positive unit price (TBD / contact supplier for pricing). */
export function isHiddenPriceCartItem(item: { price: number }): boolean {
  return !(Number(item.price) > 0);
}

export function sumPricedLines(
  items: Array<{ price: number; quantity: number }>,
): number {
  return items.reduce((sum, item) => {
    if (isHiddenPriceCartItem(item)) return sum;
    return sum + item.price * item.quantity;
  }, 0);
}

export function hiddenPriceLineCount(items: Array<{ price: number }>): number {
  return items.filter(isHiddenPriceCartItem).length;
}

/** Total units (sum of quantities) on lines with no known positive price. */
export function hiddenPriceUnits(
  items: Array<{ price: number; quantity: number }>,
): number {
  return items.reduce((sum, item) => {
    if (!isHiddenPriceCartItem(item)) return sum;
    return sum + item.quantity;
  }, 0);
}
